import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { Col, Placeholder } from "rsuite";
import "bootstrap/dist/css/bootstrap.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faPlus,
  faPen,
  faTimes,
  faCog, faFileExcel
} from "@fortawesome/free-solid-svg-icons";
import apiUrl from "../../apiUrlConstant";
import { Formik, Form, Field, ErrorMessage } from "formik";
import DataTable, {
  createTheme,
  defaultThemes,
} from "react-data-table-component";
import datatableOptions from "../../layout/datatableConstants";
import ReportsColumnSelectionView from "./ReportsColumnSelectionView";
import { Link } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";

const TextField = styled.input`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;

  &:hover {
    cursor: pointer;
  }
`;

const ClearButton = styled.button`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  columns={columns}
  height: 34px;
  width: 32px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color:#003970;
`;






const FilterComponent = ({ filterText, onFilter, onClear, prm, handleGrid, DownloadFile, columnsList }) => (
  <>

    <button onClick={handleGrid} className="ms-3"><FontAwesomeIcon icon={faCog} /></button>

    {/* <a href={apiUrl.apiUrl.url+'/lease-report/generate-summary-report?'+prm}> */}
    <button type="button" onClick={DownloadFile} className="download_button">
      Download
    </button>
    {/* </a> */}
  </>
);

const LeaseListingTable = ({ asset, brand, formConfig, expiry_report, columns, expiry_lockin_report, report_type }) => {


  if (typeof formConfig == "undefined") {
    formConfig = {
      'page': 0, 'per_page': 10
    };
  }

  //columns = columns;

  if (typeof expiry_report == "undefined") {
    var expiry_report = false;
  }

  if (typeof expiry_lockin_report == "undefined") {
    var expiry_lockin_report = false;
  }

  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);

  //);

  const [columnsList, setColumns] = useState(columns);
  const [loadedColumns, setLoadedColumns] = useState([]);

  const [show, setShow] = useState(false);
  //const [handleClose, setHide] = useState(true);


  React.useEffect(() => {
    fetchLeaseData(1);
  }, [filterText]);

  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    if (typeof expiry_report != "undefined" && expiry_report == "true") {
      formConfig['expiry_report'] = 'true';
    }

    if (typeof expiry_lockin_report != "undefined" && expiry_lockin_report == "true") {
      formConfig['expiry_lockin_report'] = 'true';
    }

    var prm = Object.entries(formConfig).map(([key, val]) => `${key}=${val}`).join('&');

    return (
      <FilterComponent
        onFilter={(e) => {
          setFilterText(e.target.value);
        }}
        onClear={handleClear}
        // key={columnsList}
        columnsList={columnsList}
        filterText={filterText}
        prm={prm}
        handleGrid={handleGrid}
        DownloadFile={DownloadFile}
      />
    );
  }, [filterText, resetPaginationToggle, columnsList]);

  const fetchLeaseData = async (page) => {

    let pageCnt = page ? page : 0;
    formConfig["page"] = pageCnt;
    formConfig["per_page"] = perPage;

    if (typeof expiry_report != "undefined" && expiry_report == "true") {
      formConfig['expiry_report'] = 'true';
    }

    if (typeof expiry_lockin_report != "undefined" && expiry_lockin_report == "true") {
      formConfig['expiry_lockin_report'] = 'true';
    }

    if (typeof formConfig['LeaseStatusName'] != "undefined" && formConfig['LeaseStatusName'] == "All") {
      formConfig['LeaseStatusName'] = '';
      formConfig['LeaseStatusId'] = 0;
    }

    var prm = Object.entries(formConfig).map(([key, val]) => `${key}=${val}`).join('&');

    setLoading(true);
    //asset=${asset}&brand=${brand}&page=${page}&per_page=${perPage}&delay=1&term=${filterText}`
    const response = await axios.get(
      `${apiUrl.apiUrl.url}/lease-report/get-all-leases?` + prm
    );

    setData(response.data.data);
    setTotalRows(response.data.total);
    setLoading(false);
  };

  const handlePageChange = (page) => {
    fetchLeaseData(page);
  };


  const handlePerRowsChange = async (newPerPage, page) => {
    setLoading(true);
    let pageCnt = page ? page : 0;
    formConfig["page"] = pageCnt;
    formConfig["per_page"] = perPage;
    if (typeof expiry_report != "undefined") {
      formConfig['expiry_report'] = 'true';
    }
    var prm = Object.entries(formConfig).map(([key, val]) => `${key}=${val}`).join('&');
    console.log(prm, "prm");

    const response = await axios.get(
      `${apiUrl.apiUrl.url}/lease-report/get-all-leases?` + prm
    );
    //`${apiUrl.apiUrl.url}/lease-report/get-all-leases?asset=${asset}&brand=${brand}&page=${page}&per_page=${newPerPage}&delay=1`
    setData(response.data.data);
    setPerPage(newPerPage);
    setLoading(false);
  };

  function handleGrid(e) {
    e.preventDefault();
    console.log('You clicked submit.');
    setShow(true);
  }
  // console.log(columnsList,"columnsList");
  // DownloadFile();
  function DownloadFile() {
    var prm = Object.entries(formConfig).map(([key, val]) => `${key}=${val}`).join('&');
    var self = this;
    axios({
      method: "post",
      url: `${apiUrl.apiUrl.url + '/lease-report/generate-summary-report?' + prm + '&sendLink=true'}`,
      data: { columnsList: columnsList }
    }).then(function (response) {
      window.location.href = `${apiUrl.apiUrl.url + '/lease-report/download-file?path=' + response.data}`;
    });

  }

  const handleClose = () => {
    setShow(false);
  }


  useEffect(() => {
    fetchLeaseData(1);
  }, []);

  // useEffect(() => {
  //  subHeaderComponentMemo;
  // }, [columnsList]);
  // subHeaderComponent={subHeaderComponentMemo}
  return (
    <>
      <div className="tableContainer">
        <DataTable

          columns={columnsList}
          data={data}
          customStyles={datatableOptions.datatableOptions.customStyle}
          progressPending={loading}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          onChangeRowsPerPage={handlePerRowsChange}
          subHeader
          subHeaderComponent={subHeaderComponentMemo}
          onChangePage={handlePageChange}
          paginationComponentOptions={
            datatableOptions.datatableOptions.paginationOptions
          }
        />
      </div>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Filter Columns</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <>
              <div>
              {columns.map(function(d, idx){
                return (<li key={idx}>{d.name}</li>)
              })}
              </div>
            
          </> */}

          <ReportsColumnSelectionView report={report_type} setColumns={setColumns} setLoadedColumns={setLoadedColumns} loadedColumns={loadedColumns} handleClose={handleClose} />

        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary">Close Modal</Button>
        </Modal.Footer> */}
      </Modal>

    </>
  );
};
export default LeaseListingTable;
